<template>
  <div style="max-width: 350px">
    <div v-if="mode === 'DESIGN'">
      <el-button disabled icon="iconfont icon-map-site" type="primary" size="mini" round> 选择部门</el-button>
      <span class="placeholder"> {{ placeholder }}</span>
    </div>
    <div v-else>
      <el-button
        icon="iconfont icon-map-site"
        type="primary"
        size="mini"
        round
        @click="selectDept"
        :disabled="!disabled">
        选择部门
      </el-button>
      <dept-picker
        type="dept"
        :multiple="multiple"
        ref="orgPicker"
        :selected="_value"
        @ok="selected"
        @close="showOrgSelect=false"
        v-if="showOrgSelect"/>
      <span class="placeholder"> {{ placeholder }}</span>
      <div style="margin-top: 5px">
        <el-tag
          size="mini"
          style="margin: 5px"
          closable
          v-for="(dept, i) in _value"
          :key="i"
          @close="delDept(i)">{{ dept.name }}</el-tag>
      </div>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import DeptPicker from '@/components/common/DeptPicker'

export default {
  mixins: [componentMinxins],
  name: 'DeptPicker',
  components: { DeptPicker },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择部门'
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showOrgSelect: false
    }
  },
  created () {
    console.log('DeptPicker---->>>>>>>', this.mode)
  },
  methods: {
    selected (values) {
      this.showOrgSelect = false
      this._value = values
    },
    delDept (i) {
      this._value.splice(i, 1)
    },
    selectDept () {
      this.orgPickerType = 'Dept'
      this.showOrgSelect = true
      console.log('选择部门按钮点击')
      // this.$refs.orgPicker.show()
    }
  }
}
</script>

<style scoped>
.placeholder{
  margin-left: 10px;
  color: #adabab;
  font-size: smaller;
}
</style>
